import React from 'react';
import { useGetProgramsByDatasourceIdQuery } from 'Services/api/programApi';
import { noValue } from 'helper/validation';
import { SelectObjectById } from './SelectObjectById';

/**
 * Компонент выбора программ по айди источника с выгрузкой с сервера
 * @param selected айди выбранной программы
 * @param onSelecte (programId: number, program: object) => void
 * @param {number} datasourceId для запроса
 * @param {number} [phenomenonTypeId] для фильтрации программ по типу явления
 */
export const SelectDatasourceProgram = React.memo(({
  selected,
  onChangeValue,
  firstOptionLabel,
  datasourceId,
  phenomenonTypeId, // 0 не может быть
  observationTypeId, // 0 не может быть
  ...selectProps
}) => {
  const { data: programs, isLoading, isFetching } = useGetProgramsByDatasourceIdQuery(datasourceId, { skip: noValue(datasourceId) });
  // const optionLabel = (program) => program.name;
  const optionLabel = (program) => `${program.id} - ${program.name}`;

  // const filteredPrograms = React.useMemo(() => (
  //   phenomenonTypeId
  //     ? programs.filter(({ phenomenonType }) => (
  //       phenomenonType && phenomenonType.id === phenomenonTypeId
  //     ))
  //     : programs
  // ), [phenomenonTypeId, programs]);
  const filteredPrograms = React.useMemo(() => {
    if (observationTypeId && phenomenonTypeId) {
      return programs.filter(({ observationType, phenomenonType }) => {
        // если совпало по типу наблюдения, но отсутствует тип явления
        if (observationType.id === observationTypeId && !phenomenonType) return true;
        if (observationType.id === observationTypeId && phenomenonType && phenomenonType.id === phenomenonTypeId) return true;
        return false;
      });
    }
    if (observationTypeId) {
      return programs.filter(({ observationType }) => (
        observationType.id === observationTypeId
      ));
    }
    if (phenomenonTypeId) {
      return programs.filter(({ phenomenonType }) => (
        phenomenonType.id === phenomenonTypeId
      ));
    }
    return programs;
  }, [observationTypeId, phenomenonTypeId, programs]);

  return (
    <SelectObjectById
      {...selectProps}
      name="datasourceProgram"
      data={filteredPrograms}
      selected={selected}
      onChangeValue={onChangeValue}
      isLoading={isLoading || isFetching}
      firstOptionLabel={firstOptionLabel || 'ВСЕ'}
      optionLabel={optionLabel}
    />
  );
});

SelectDatasourceProgram.displayName = 'SelectDatasourceProgram';
